import { render, staticRenderFns } from "./UiContestEntry.vue?vue&type=template&id=4a41ea66&"
import script from "./UiContestEntry.vue?vue&type=script&lang=js&"
export * from "./UiContestEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports